import { render, staticRenderFns } from "./ReceptionMain.vue?vue&type=template&id=5263a5aa&scoped=true"
import script from "./ReceptionMain.vue?vue&type=script&lang=js"
export * from "./ReceptionMain.vue?vue&type=script&lang=js"
import style0 from "./ReceptionMain.vue?vue&type=style&index=0&id=5263a5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263a5aa",
  null
  
)

export default component.exports